import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@rezolved/auth';
import { MxpPaymentGrpcClient, GetByIdRequest, PaymentStatusEnum, PaymentTypeEnum, GetPaymentStatusResponse } from '@rezolved/mxp-proto';
import * as moment from 'moment';
import { Subscription, interval } from 'rxjs';
import { first } from 'rxjs/operators';
import { DateFormatOptions } from '../../../core/constants/DateFormatOptions';
import { DEFAULT_PAYMENT_EXPIRATION_IN_MONTHS } from '../../../core/constants/payment-constants';
import Route from '../../../core/constants/Route';
import { PaymentSentConfiguration } from '../../../core/interfaces/payment-sent-configuration';

@Component({
  selector: 'mxp-payment-sent',
  templateUrl: './payment-sent.component.html',
  styleUrls: ['./payment-sent.component.scss'],
})
export class PaymentSentComponent implements OnInit, OnDestroy {
  @Input()
  configuration!: PaymentSentConfiguration;

  @Input()
  timeRange = 10;

  protected subscription?: Subscription;
  counter = 0;
  PaymentType = PaymentTypeEnum;

  constructor(
    protected router: Router,
    private mxpPaymentGrpcClient: MxpPaymentGrpcClient,
    private authService: AuthService,
  ) {}

  get expiryDate(): string {
    if (this.configuration?.paymentConfiguration?.expiryDate) {
      return moment(this.configuration?.paymentConfiguration?.expiryDate.toDate())
        .format(DateFormatOptions.DEFAULT_PAYMENT_DATE);   
    } else {
      return 'EXPIRY_DATE_REQUIRED';
    }
  }

  get isPaymentWithoutAmount(): boolean {
    return (
      this.configuration?.paymentConfiguration?.price === '0' || this.configuration?.paymentConfiguration?.price == null
    );
  }

  updateTimer(): void {
    if (this.counter === 0) {
      this.counter = this.timeRange;
      this.authService.user$.pipe(first()).subscribe((user) => {
        if (user && this.configuration?.paymentConfiguration?.id) {
          const paymentStatusRequest = new GetByIdRequest({
            id: this.configuration.paymentConfiguration.id,
          });
          this.mxpPaymentGrpcClient.getPaymentStatus(paymentStatusRequest).subscribe(
            (response) => {
              if (response) {
                switch (response.status) {
                  case PaymentStatusEnum.PAYMENT_MADE:
                    this.redirectByPaymentStatus(response, true);
                    break;
                  case PaymentStatusEnum.REQUEST_REJECTED:
                    this.redirectByPaymentStatus(response, false);
                    break;
                  default:
                    break;
                }
              }
            },
            (error) => console.log(error),
          );
        }
      });

      return;
    }
    this.counter--;
  }

  redirectByPaymentStatus(response: GetPaymentStatusResponse,isPaid: boolean): void {
    this.router.navigate([Route.PAYMENT_STATUS], {
      state: {
        paymentStatus: response,
        imageUrl: isPaid ? '/assets/svg/payment-received.svg' : '/assets/svg/payment-rejected.svg',
        primaryStatusText: isPaid ?'PAYMENT_RECEIVED' : 'PAYMENT_CANCELLED',
        secondaryStatusText: isPaid ? 'PAID': '',
      },
    });
  }

  cancelRequest(): void {
    this.router.navigate([Route.REQUEST_PAYMENT]);
  }

  setupPayment(): void {
    this.subscription = interval(1000).subscribe(() => {
      this.updateTimer();
    });
  }

  ngOnInit() {
    if (!this.isPaymentWithoutAmount) {
      this.setupPayment();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}